var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 376,
    height: 754,
    viewBox: "0 0 376 754",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.1111 467.826L90.5 475L89.8889 467.826L85 467.174L89.8889 466.522L90.5 460L91.1111 466.522L96 467.174L91.1111 467.826Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.1111 479.826L66.5 487L65.8889 479.826L61 479.174L65.8889 478.522L66.5 472L67.1111 478.522L72 479.174L67.1111 479.826Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.11111 668.826L5.5 676L4.88889 668.826L0 668.174L4.88889 667.522L5.5 661L6.11111 667.522L11 668.174L6.11111 668.826Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.111 467.826L361.5 475L360.889 467.826L356 467.174L360.889 466.522L361.5 460L362.111 466.522L367 467.174L362.111 467.826Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.22222 631.13L2 634L1.77778 631.13L0 630.87L1.77778 630.609L2 628L2.22222 630.609L4 630.87L2.22222 631.13Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.222 566.13L205 569L204.778 566.13L203 565.87L204.778 565.609L205 563L205.222 565.609L207 565.87L205.222 566.13Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.222 464.13L237 467L236.778 464.13L235 463.87L236.778 463.609L237 461L237.222 463.609L239 463.87L237.222 464.13Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.222 574.13L367 577L366.778 574.13L365 573.87L366.778 573.609L367 571L367.222 573.609L369 573.87L367.222 574.13Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.222 653.13L360 656L359.778 653.13L358 652.87L359.778 652.609L360 650L360.222 652.609L362 652.87L360.222 653.13Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.222 642.13L218 645L217.778 642.13L216 641.87L217.778 641.609L218 639L218.222 641.609L220 641.87L218.222 642.13Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2222 676.13L85 679L84.7778 676.13L83 675.87L84.7778 675.609L85 673L85.2222 675.609L87 675.87L85.2222 676.13Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.444 660.739L100 666L99.5556 660.739L96 660.261L99.5556 659.783L100 655L100.444 659.783L104 660.261L100.444 660.739Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.222 723.13L214 726L213.778 723.13L212 722.87L213.778 722.609L214 720L214.222 722.609L216 722.87L214.222 723.13Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.222 750.13L245 753L244.778 750.13L243 749.87L244.778 749.609L245 747L245.222 749.609L247 749.87L245.222 750.13Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.222 738.13L150 741L149.778 738.13L148 737.87L149.778 737.609L150 735L150.222 737.609L152 737.87L150.222 738.13Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2222 563.13L31 566L30.7778 563.13L29 562.87L30.7778 562.609L31 560L31.2222 562.609L33 562.87L31.2222 563.13Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.556 116.043L375.5 117L375.444 116.043L375 115.957L375.444 115.87L375.5 115L375.556 115.87L376 115.957L375.556 116.043Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 143.5,
    cy: 505.5,
    r: 0.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324 676L323.5 681.5L323 676L319 675.5L323 675L323.5 670L324 675L328 675.5L324 676Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 287.5,
    cy: 680.5,
    r: 0.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 338.5,
    cy: 655.5,
    r: 0.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 338.5,
    cy: 646.5,
    r: 0.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 339.5,
    cy: 626.5,
    r: 0.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 365.5,
    cy: 597.5,
    r: 0.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350.5,
    cy: 547.5,
    r: 0.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 327.5,
    cy: 565.5,
    r: 0.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 319.5,
    cy: 642.5,
    r: 0.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 239.5,
    cy: 565.5,
    r: 0.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265.5,
    cy: 561.5,
    r: 0.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 279.5,
    cy: 560.5,
    r: 0.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 170.5,
    cy: 569.5,
    r: 0.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 160.5,
    cy: 541.5,
    r: 0.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 142.5,
    cy: 569.5,
    r: 0.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104.5,
    cy: 572.5,
    r: 0.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 218.5,
    cy: 662.5,
    r: 0.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.5,
    cy: 652.5,
    r: 0.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.5,
    cy: 689.5,
    r: 0.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 122.5,
    cy: 700.5,
    r: 0.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 707.5,
    r: 0.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.5,
    cy: 725.5,
    r: 0.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 299.5,
    cy: 622.5,
    r: 0.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288.5,
    cy: 649.5,
    r: 0.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 260.5,
    cy: 682.5,
    r: 0.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 195.5,
    cy: 688.5,
    r: 0.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 188.5,
    cy: 708.5,
    r: 0.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 169.5,
    cy: 753.5,
    r: 0.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 262.5,
    cy: 727.5,
    r: 0.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 357.5,
    cy: 520.5,
    r: 0.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 339.5,
    cy: 467.5,
    r: 0.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 311.5,
    cy: 464.5,
    r: 0.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 257.5,
    cy: 479.5,
    r: 0.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333.5,
    cy: 491.5,
    r: 0.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 337.5,
    cy: 514.5,
    r: 0.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 287.5,
    cy: 494.5,
    r: 0.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 273.5,
    cy: 495.5,
    r: 0.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.5,
    cy: 502.5,
    r: 0.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 235.5,
    cy: 486.5,
    r: 0.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 217.5,
    cy: 474.5,
    r: 0.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194.5,
    cy: 502.5,
    r: 0.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194.5,
    cy: 502.5,
    r: 0.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194.5,
    cy: 502.5,
    r: 0.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 459.5,
    r: 0.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74.5,
    cy: 460.5,
    r: 0.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 117.5,
    cy: 474.5,
    r: 0.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.5,
    cy: 505.5,
    r: 0.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.5,
    cy: 478.5,
    r: 0.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 77.5,
    cy: 514.5,
    r: 0.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.5,
    cy: 560.5,
    r: 0.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 630.5,
    r: 0.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80.5,
    cy: 613.5,
    r: 0.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 617.5,
    r: 0.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 610.5,
    r: 0.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91.5,
    cy: 636.5,
    r: 0.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.5,
    cy: 666.5,
    r: 0.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156.5,
    cy: 647.5,
    r: 0.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 88.5,
    cy: 583.5,
    r: 0.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 208.5,
    cy: 516.5,
    r: 0.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 171,
    cy: 496,
    r: 1,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 318,
    cy: 475,
    r: 1,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290,
    cy: 459,
    r: 1,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 501,
    r: 1,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 187,
    cy: 536,
    r: 1,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138,
    cy: 587,
    r: 1,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 344,
    cy: 559,
    r: 1,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288.5,
    cy: 708.5,
    r: 0.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.889 167.826L278.5 175L279.111 167.826L284 167.174L279.111 166.522L278.5 160L277.889 166.522L273 167.174L277.889 167.826Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.889 179.826L302.5 187L303.111 179.826L308 179.174L303.111 178.522L302.5 172L301.889 178.522L297 179.174L301.889 179.826Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.889 368.826L363.5 376L364.111 368.826L369 368.174L364.111 367.522L363.5 361L362.889 367.522L358 368.174L362.889 368.826Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.88889 167.826L7.5 175L8.11111 167.826L13 167.174L8.11111 166.522L7.5 160L6.88889 166.522L2 167.174L6.88889 167.826Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.778 331.13L367 334L367.222 331.13L369 330.87L367.222 330.609L367 328L366.778 330.609L365 330.87L366.778 331.13Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.778 266.13L164 269L164.222 266.13L166 265.87L164.222 265.609L164 263L163.778 265.609L162 265.87L163.778 266.13Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.778 164.13L132 167L132.222 164.13L134 163.87L132.222 163.609L132 161L131.778 163.609L130 163.87L131.778 164.13Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.77778 274.13L2 277L2.22222 274.13L4 273.87L2.22222 273.609L2 271L1.77778 273.609L0 273.87L1.77778 274.13Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.77778 353.13L9 356L9.22222 353.13L11 352.87L9.22222 352.609L9 350L8.77778 352.609L7 352.87L8.77778 353.13Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.778 342.13L151 345L151.222 342.13L153 341.87L151.222 341.609L151 339L150.778 341.609L149 341.87L150.778 342.13Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.778 376.13L284 379L284.222 376.13L286 375.87L284.222 375.609L284 373L283.778 375.609L282 375.87L283.778 376.13Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.556 360.739L269 366L269.444 360.739L273 360.261L269.444 359.783L269 355L268.556 359.783L265 360.261L268.556 360.739Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.778 423.13L155 426L155.222 423.13L157 422.87L155.222 422.609L155 420L154.778 422.609L153 422.87L154.778 423.13Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.778 450.13L124 453L124.222 450.13L126 449.87L124.222 449.609L124 447L123.778 449.609L122 449.87L123.778 450.13Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.778 438.13L219 441L219.222 438.13L221 437.87L219.222 437.609L219 435L218.778 437.609L217 437.87L218.778 438.13Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.778 263.13L338 266L338.222 263.13L340 262.87L338.222 262.609L338 260L337.778 262.609L336 262.87L337.778 263.13Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(-1 0 0 1 225.5 205.5)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 376L45.5 381.5L46 376L50 375.5L46 375L45.5 370L45 375L41 375.5L45 376Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(-1 0 0 1 81.5 380.5)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(-1 0 0 1 30.5 355.5)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(-1 0 0 1 30.5 346.5)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(-1 0 0 1 29.5 326.5)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(-1 0 0 1 3.5 297.5)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(-1 0 0 1 18.5 247.5)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(-1 0 0 1 41.5 265.5)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(-1 0 0 1 49.5 342.5)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(-1 0 0 1 129.5 265.5)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(-1 0 0 1 103.5 261.5)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(-1 0 0 1 89.5 260.5)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(-1 0 0 1 198.5 269.5)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(-1 0 0 1 208.5 241.5)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(-1 0 0 1 226.5 269.5)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(-1 0 0 1 264.5 272.5)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(-1 0 0 1 150.5 362.5)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(-1 0 0 1 110.5 352.5)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(-1 0 0 1 220.5 389.5)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(-1 0 0 1 246.5 400.5)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(-1 0 0 1 320.5 407.5)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(-1 0 0 1 285.5 425.5)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(-1 0 0 1 69.5 322.5)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(-1 0 0 1 80.5 349.5)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(-1 0 0 1 108.5 382.5)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(-1 0 0 1 173.5 388.5)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(-1 0 0 1 180.5 408.5)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(-1 0 0 1 199.5 453.5)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(-1 0 0 1 106.5 427.5)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(-1 0 0 1 11.5 220.5)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(-1 0 0 1 29.5 167.5)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(-1 0 0 1 57.5 164.5)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(-1 0 0 1 111.5 179.5)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(-1 0 0 1 35.5 191.5)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(-1 0 0 1 31.5 214.5)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(-1 0 0 1 81.5 194.5)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(-1 0 0 1 95.5 195.5)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(-1 0 0 1 130.5 202.5)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(-1 0 0 1 133.5 186.5)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(-1 0 0 1 151.5 174.5)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(-1 0 0 1 174.5 202.5)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(-1 0 0 1 174.5 202.5)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(-1 0 0 1 174.5 202.5)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(-1 0 0 1 333.5 159.5)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(-1 0 0 1 294.5 160.5)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(-1 0 0 1 251.5 174.5)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(-1 0 0 1 248.5 205.5)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(-1 0 0 1 234.5 178.5)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(-1 0 0 1 291.5 214.5)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(-1 0 0 1 304.5 260.5)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(-1 0 0 1 340.5 330.5)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(-1 0 0 1 288.5 313.5)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(-1 0 0 1 314.5 317.5)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(-1 0 0 1 326.5 310.5)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(-1 0 0 1 277.5 336.5)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(-1 0 0 1 236.5 366.5)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(-1 0 0 1 212.5 347.5)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(-1 0 0 1 280.5 283.5)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(-1 0 0 1 160.5 216.5)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1,
    transform: "matrix(-1 0 0 1 198 196)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1,
    transform: "matrix(-1 0 0 1 51 175)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1,
    transform: "matrix(-1 0 0 1 79 159)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1,
    transform: "matrix(-1 0 0 1 341 201)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1,
    transform: "matrix(-1 0 0 1 182 236)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1,
    transform: "matrix(-1 0 0 1 231 287)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1,
    transform: "matrix(-1 0 0 1 25 259)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(-1 0 0 1 80.5 408.5)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.11111 58.8261L5.5 66L4.88889 58.8261L0 58.1739L4.88889 57.5217L5.5 51L6.11111 57.5217L11 58.1739L6.11111 58.8261Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.22222 21.1304L2 24L1.77778 21.1304L0 20.8696L1.77778 20.6087L2 18L2.22222 20.6087L4 20.8696L2.22222 21.1304Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.222 43.1304L360 46L359.778 43.1304L358 42.8696L359.778 42.6087L360 40L360.222 42.6087L362 42.8696L360.222 43.1304Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.222 32.1304L218 35L217.778 32.1304L216 31.8696L217.778 31.6087L218 29L218.222 31.6087L220 31.8696L218.222 32.1304Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2222 66.1304L85 69L84.7778 66.1304L83 65.8696L84.7778 65.6087L85 63L85.2222 65.6087L87 65.8696L85.2222 66.1304Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.444 50.7391L100 56L99.5556 50.7391L96 50.2609L99.5556 49.7826L100 45L100.444 49.7826L104 50.2609L100.444 50.7391Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.222 113.13L214 116L213.778 113.13L212 112.87L213.778 112.609L214 110L214.222 112.609L216 112.87L214.222 113.13Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.222 140.13L245 143L244.778 140.13L243 139.87L244.778 139.609L245 137L245.222 139.609L247 139.87L245.222 140.13Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.222 128.13L150 131L149.778 128.13L148 127.87L149.778 127.609L150 125L150.222 127.609L152 127.87L150.222 128.13Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324 66L323.5 71.5L323 66L319 65.5L323 65L323.5 60L324 65L328 65.5L324 66Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 287.5,
    cy: 70.5,
    r: 0.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 338.5,
    cy: 45.5,
    r: 0.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 338.5,
    cy: 36.5,
    r: 0.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 339.5,
    cy: 16.5,
    r: 0.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 319.5,
    cy: 32.5,
    r: 0.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 218.5,
    cy: 52.5,
    r: 0.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.5,
    cy: 42.5,
    r: 0.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.5,
    cy: 79.5,
    r: 0.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 122.5,
    cy: 90.5,
    r: 0.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 97.5,
    r: 0.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.5,
    cy: 115.5,
    r: 0.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 299.5,
    cy: 12.5,
    r: 0.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288.5,
    cy: 39.5,
    r: 0.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 260.5,
    cy: 72.5,
    r: 0.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 195.5,
    cy: 78.5,
    r: 0.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 188.5,
    cy: 98.5,
    r: 0.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 169.5,
    cy: 143.5,
    r: 0.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 262.5,
    cy: 117.5,
    r: 0.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 20.5,
    r: 0.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80.5,
    cy: 3.5,
    r: 0.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 7.5,
    r: 0.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 0.5,
    r: 0.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91.5,
    cy: 26.5,
    r: 0.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.5,
    cy: 56.5,
    r: 0.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156.5,
    cy: 37.5,
    r: 0.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288.5,
    cy: 98.5,
    r: 0.5,
    fill: "#D9D9D9"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.876a04daec85f89d8d179b040030689f.svg";
export { ForwardRef as ReactComponent };